import { call, put, takeEvery, select, fork } from "redux-saga/effects"
import { toast } from "react-toastify"
// Crypto Redux States
import FabricOrderType from "./actionTypes"

import FabricOrderAction from "./actions"
import moment from "moment"
import FabricOrderAPI from "helpers/fabric_order_backend_helper"

function* fetchListOnPage({ payload }) {
  yield put(
    FabricOrderAction.getListPageSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    const currentPage = payload.page
    let { data } = yield call(FabricOrderAPI.getListPage, {
      ...payload,
      orderDateFrom:
        payload.orderDateFrom !== ""
          ? moment(payload.orderDateFrom).format("YYYY-MM-DD")
          : "",
      orderDateTo:
        payload.orderDateTo !== ""
          ? moment(payload.orderDateTo).format("YYYY-MM-DD")
          : "",
      page: currentPage,
    })
    yield put(
      FabricOrderAction.getListPageSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      FabricOrderAction.getListPageSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchDetail({ payload, action }) {
  yield put(
    FabricOrderAction.getDetailSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(FabricOrderAPI.getDetail, payload.id)

    action(data)
    yield put(
      FabricOrderAction.getDetailSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      FabricOrderAction.getDetailSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchPostData({ payload, action }) {
  yield put(
    FabricOrderAction.postDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(FabricOrderAPI.postData, payload)

    yield put(
      FabricOrderAction.postDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    yield put(
      FabricOrderAction.postDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchPutData({ payload, action }) {
  yield put(
    FabricOrderAction.putDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(FabricOrderAPI.putData, payload)

    yield put(
      FabricOrderAction.putDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    yield put(
      FabricOrderAction.putDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchList({ payload }) {
  yield put(
    FabricOrderAction.getListSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(FabricOrderAPI.getListOrder, payload)
    yield put(
      FabricOrderAction.getListSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      FabricOrderAction.getListSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchListNumber({ payload }) {
  yield put(
    FabricOrderAction.getListNumberSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(FabricOrderAPI.getListNumber, payload)
    yield put(
      FabricOrderAction.getListNumberSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      FabricOrderAction.getListNumberSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchListCustomer({ payload }) {
  yield put(
    FabricOrderAction.getListCustomerSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(FabricOrderAPI.getListCustomer, payload)
    yield put(
      FabricOrderAction.getListCustomerSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      FabricOrderAction.getListCustomerSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchListBunch({ payload }) {
  yield put(
    FabricOrderAction.getListBunchSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(FabricOrderAPI.getListBunch, payload)
    yield put(
      FabricOrderAction.getListBunchSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      FabricOrderAction.getListBunchSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchListBrand({ payload }) {
  yield put(
    FabricOrderAction.getListBrandSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(FabricOrderAPI.getListBrand, payload)
    yield put(
      FabricOrderAction.getListBrandSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      FabricOrderAction.getListBrandSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fabricOrderSaga() {
  yield takeEvery(FabricOrderType.GET_FABRIC_ORDER_PAGES, fetchListOnPage)
  yield takeEvery(FabricOrderType.GET_DETAIL_FABRIC_ORDER_BY_ID, fetchDetail)
  yield takeEvery(FabricOrderType.POST_FABRIC_ORDER, fetchPostData)
  yield takeEvery(FabricOrderType.PUT_FABRIC_ORDER, fetchPutData)
  yield takeEvery(FabricOrderType.GET_FABRIC_ORDER_LIST, fetchList)
  yield takeEvery(FabricOrderType.GET_FABRIC_NUMBER_LIST, fetchListNumber)
  yield takeEvery(
    FabricOrderType.GET_FABRIC_CUSTOMER_NAME_LIST,
    fetchListCustomer
  )
  yield takeEvery(FabricOrderType.GET_FABRIC_BUNCH_LIST, fetchListBunch)
  yield takeEvery(FabricOrderType.GET_FABRIC_BRAND_LIST, fetchListBrand)
}

export default fabricOrderSaga
